var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58118 0 0 3.58118 0 8C0 12.4188 3.58118 16 8 16C12.4188 16 16 12.4188 16 8C15.9906 3.58588 12.4141 0.00941177 8 0ZM2.82353 8C2.7953 5.16706 5.07294 2.84706 7.90588 2.82353C8.81882 2.81412 9.71294 3.04941 10.5035 3.50118L3.50118 10.5035C3.06353 9.74118 2.83294 8.88 2.82353 8ZM8 13.1765C7.12 13.1671 6.25882 12.9365 5.49647 12.4988L12.4988 5.49647C13.9059 7.95294 13.0588 11.0871 10.5976 12.4988C9.80706 12.9506 8.90824 13.1859 8 13.1765Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeze);
export default __webpack_public_path__ + "static/media/freeze.60e89ce7c5768444648af87e7e6800ef.svg";
export { ForwardRef as ReactComponent };